import { createContext } from 'react';

const ProseMirrorEditorViewContext = createContext<any>(null);

export default ProseMirrorEditorViewContext;
